export default __webpack_public_path__ + "234cc719f1d47d92a3f8bb7bcc1bedcf.obj";